import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useMemo } from "react";
import { GenerateMedicaoColumns } from "./columns";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useNavigate } from "react-router";
import { MedicaoTerceirizacaoLista } from "../../../domain/models/medicao_terceirizacao_lista";
import { useMedicaoListaViewModel } from "../../viewModels/medicao_terceirizacao_lista_view_model";
import { LegendaModal } from "./components/legenda_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";


export const MedicaoTerceirizacao_lista = () => {
  const navigate = useNavigate();
  const viewModel = useMedicaoListaViewModel();
  const MedicaoListalColumns = useMemo(() => {
    return GenerateMedicaoColumns({
      onActionEditar: viewModel.handleCadastroMedicaoOpenState,
      onActionDeletar: viewModel.handleDeleteMedicaoModalOpenState,
      onActionExport: viewModel.handleReportMedicaoTerceirizacao,
    });
  }, [viewModel.handleCadastroMedicaoOpenState, viewModel.handleDeleteMedicaoModalOpenState, viewModel.handleReportMedicaoTerceirizacao]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[100px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => navigate("/MedicaoTerceirizacao_cadastro/")}>
                  Novo
                </PrimaryButton>
              </div>
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Terceirização
            </Link>
            <Typography className="text-primary-green">
              Medição
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Medição  Lista</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            centroDeCusto={viewModel.filters.centroDeCusto}
            centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
            FornecedorPesquisa={viewModel.filters.FornecedorPesquisa}
            NMedicaoPesquisa={viewModel.filters.NMedicaoPesquisa}
            StatusPesquisa={viewModel.filters.StatusPesquisa}
            ContratoPesquisa={viewModel.filters.ContratoPesquisa}
            handleContratoChange={viewModel.handleContratoChange}
            handleFornecedorChange={viewModel.handleFornecedorChange}
            handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
            handleNMedicaoCampoChange={viewModel.handleNMedicaoCampoChange}
            handleStatusPesquisa={viewModel.handleStatusPesquisaChange}
          />
          <div className="w-[180px]">
            <span
              className="text-[#009C4E] bg-transparent border border-[#009C4E] px-2 py-1 text-sm rounded rounded-base font-semibold cursor-pointer"
              onClick={() => viewModel.handleShowLegenda(true)}>
              Legenda
            </span>
          </div>
          <StyledDataGrid
            tableName="Medicao_lista"
            disableColumnMenu={false}
            getRowId={(row: MedicaoTerceirizacaoLista) => row.IdMedicaoTerceirizacao}
            columns={MedicaoListalColumns}
            loading={viewModel.loading}
            rows={viewModel.MedicaoLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ['IdMedicaoTerceirizacao'],
            }}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>
      <DeleteDialog
        open={viewModel.MedicaoDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteMedicaoModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaMedicao} />
      <LegendaModal
        open={viewModel.openLegendaModal}
        onClose={() => viewModel.handleShowLegenda(false)}
      />

      {/* Relatorio */}
      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
    </>
  );

}


